import React from 'react';

const { ScrollTopCache, CONSTANTS } = sfp.scriptLibs;
const { OVERLAY_ACTIVE_CLASS } = CONSTANTS;

export class Overlay extends React.Component {
  componentDidMount() {
    this.scrollTopCache = new ScrollTopCache();
    this.scrollTopCache.update();
    document.querySelector('html').classList.add(OVERLAY_ACTIVE_CLASS);
  }

  componentWillUnmount() {
    setTimeout(() => {
      document.querySelector('html').classList.remove(OVERLAY_ACTIVE_CLASS);
      this.scrollTopCache.apply();
    }, 0);
  }

  render() {
    return (
      <div className={'WorkshopsOverlay Overlay ' + OVERLAY_ACTIVE_CLASS}>
        {this.props.children}
      </div>
    );
  }
}
